import React, { Component } from 'react'
import PreloaderTwo from '../preloader/PreloaderTwo';
import { Container, Row, Col, Card, Button, Image, Form, Table, Badge, Modal } from 'react-bootstrap';
import DataTableWithOutSearch from '../datatables/DataTableWithOutSearch';
import './_admissiontest.scss';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import axios, { post } from "axios";
import moment from 'moment';



const FETCH_ADMISSION_TEST = gql` 
query($institution_id: Int!) {
    getAdimissionTestResults(institution_id: $institution_id){
        title
        description
        class_ids
        category_ids
        branch_ids
        section_ids
        student_ids
        timestamp
        
    }
}

`;

const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        classes{
            id
            class
        }
        globalBranches{
            id
            branch_name
        }
        globalSections{
            id
            section_name
            branch_id
            category_id
        }
        globalCategories{
            id
            category_name
        }
        
    }
}

`;

class AdmissionHomePage extends Component {
    constructor(props) {
        super(props)
        console.log("UserCreationSection", this.props);
        this.state = {
            tableHeaderData: {
                Title: 'Test Results Table'
            },
            modalShow: false,
            modalShow1: false,
            //form field
            image: "",
            image_filename: "Choose File",
            formValid: false,
            currentStep: "1",
            submitError: "",
            classname: "",
            classnamevalue: "",
            branchvalue: [],
            branch: [],
            category: "",
            categoryvalue: "",
            sectionvalue: [],
            section: [],
            title: "",
            message: "",
            ldescription: "",
            formErrors: {
                classname: "",
                branch: "",
                category: "",
                section: "",
                title: "",
                message: "",
                ldescription: ""
            },
            classnameValid: true,
            branchValid: true,
            categoryValid: false,
            sectionValid: true,
            titleValid: false,
            messageValid: false,
            ldescriptionValid: false,
            SendInstituteNotification: '',


        }
    }

    articlecolumns = [
        {
            dataField: "title",
            text: "Title",
            sort: true
        }
        ,
        {
            dataField: "date",
            text: "Date",
            sort: true
        },
        {
            dataField: "time",
            text: "Time",
            sort: true
        },
        {
            dataField: "description",
            text: "Description",
            sort: true,
        },

        {
            dataField: "class",
            text: "Class",
            sort: true
        },

        {
            dataField: "branch",
            text: "Branch",
            sort: true
        },
        {
            dataField: "section",
            text: "Section",
            sort: true
        },
        {
            dataField: "category",
            text: "Category",
            sort: true
        }


    ];

    defaultSorted = [
        {
            dataField: "date",
            order: "desc"
        }
    ];

    tableUserData(notifystudent) {
        console.log("notifystudent", this.props);
        const newArray = [];
        //let classname="";

        if (notifystudent) {
            notifystudent.map((mapdata) => {
                let getDataclass_ids = [];
                if (mapdata.class_ids != "") {

                    let carray = mapdata.class_ids.split(",");
                    carray.map((item) => {
                        let findclass = this.props.globals.globals.classes.find((a) => a.id == item);
                        if (findclass != undefined) {
                            getDataclass_ids.push(findclass.class);
                        }

                    })

                }

                console.log("getDataclass_ids", getDataclass_ids);

                let getDatacategory_ids = [];
                if (mapdata.category_ids != "") {

                    let carray = mapdata.category_ids.split(",");
                    carray.map((item) => {
                        let findcategory = this.props.globals.globals.globalCategories.find((a) => a.id == item);
                        if (findcategory != undefined) {
                            getDatacategory_ids.push(findcategory.category_name);
                        }

                    })

                }


                let getData = [];
                if (mapdata.branch_ids != "") {

                    let barray = mapdata.branch_ids.split(",");
                    barray.map((item) => {
                        let findbranch = this.props.globals.globals.globalBranches.find((a) => a.id == item);
                        if (findbranch != undefined) {
                            getData.push(findbranch.branch_name);
                        }

                    })

                }

                let getDatasection = [];
                if (mapdata.section_ids != "") {

                    let carray = mapdata.section_ids.split(",");
                    carray.map((item) => {
                        let findsection = this.props.globals.globals.globalSections.find((a) => a.id == item);
                        if (findsection != undefined) {
                            getDatasection.push(findsection.section_name);
                        }

                    })

                }
                const newObj = {
                    branch_ids: mapdata.branch_ids,
                    category_ids: mapdata.category_ids,
                    class_ids: mapdata.class_ids,
                    section_ids: mapdata.section_ids,
                    branch: getData.toString(),
                    category: getDatacategory_ids.toString(),
                    class: getDataclass_ids.toString(),
                    section: getDatasection.toString(),
                    description: mapdata.description,
                    title: mapdata.title,
                    date: moment.unix(mapdata.timestamp).format("YYYY/MM/DD"),
                    time: moment.unix(mapdata.timestamp).format("LT")
                }
                newArray.push(newObj);

            })
        }
        return newArray;


    }

    render() {

        console.log("currentstate", this.state);
        const getAdimissionTestResults = this.props.getAdimissionTestResults;
        const loading3 = getAdimissionTestResults.loading;
        const error3 = getAdimissionTestResults.error;

        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        if (loading3 || loading1) return <PreloaderTwo />;

        return (
            <React.Fragment>
                <div className="user-creation">
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-3 my-4 d-flex align-items-center justify-content-between">
                                <h2 className="title font-weight-normal h5 mb-0">Admission Test</h2>
                                {/* {this.state.modalShow == false ? (<Button className="btn btn-blue px-4" onClick={this.parentStateSet}>Send Notification</Button>) : ("")} */}
                            </div>
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12} >
                        <div className="card-title mb-0 text-danger">
                            {this.state.status == 2 ? "User deleted successfully" : ""}
                        </div>
                        <DataTableWithOutSearch
                            parentData={this.tableUserData(
                                getAdimissionTestResults.getAdimissionTestResults
                            )}
                            particlecolumns={this.articlecolumns}
                            tableHeading={this.state.tableHeaderData}
                            defaultSorted={this.defaultSorted}
                            name={this.state.tableHeaderData.Title}
                        />
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}


export default compose(
    graphql(FETCH_ADMISSION_TEST,
        {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },
                fetchPolicy: 'network-only',
                nextFetchPolicy: "network-only"
            }), name: "getAdimissionTestResults"
        }),
    graphql(FETCH_GLOBALS,
        {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                }
            }), name: "globals"
        }),
    // graphql(ADDNOTIFYSTUDENT, {
    //     name: "notifystudent"
    // }),
    // graphql(ADDNOTIFYSTUDENTONE, {
    //     name: "sendids"
    // })
)
    (AdmissionHomePage);